// Slider
export default function getSliderMark({ type = "", value, label }) {
  return {
    type: type,
    value: value,
    label: label,
  };
}
